"use client";

import Prose from "@/components/shared/prose";
import { ShopProductPageData } from "@/lib/product-page/product-page-types";
import { useEffect, useRef, useState } from "react";

export function ProductDescription({ shopProduct }: { shopProduct: ShopProductPageData }) {
    const [isExpanded, setIsExpanded] = useState(false);
    const [shouldShowButton, setShouldShowButton] = useState(false);
    const contentRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (contentRef.current) {
            const scrollHeight = contentRef.current.scrollHeight;
            const clientHeight = contentRef.current.clientHeight;

            setShouldShowButton(scrollHeight > clientHeight);
        }
    }, [shopProduct.description]);

    if (!shopProduct.description) {
        return null;
    }

    return (
        <div className="mb-6">
            <div
                ref={contentRef}
                className={`transition-all duration-300 ease-in-out ${
                    !isExpanded ? "line-clamp-5" : ""
                }`}
            >
                <Prose
                    className="text-sm leading-tight dark:text-white/[60%]"
                    html={shopProduct.description}
                />
            </div>

            {shouldShowButton && (
                <button
                    onClick={() => setIsExpanded(!isExpanded)}
                    className="mt-2 rounded text-sm font-medium text-emerald-500 transition-colors duration-200 hover:text-emerald-800 hover:underline focus:outline-none focus:ring-offset-2 dark:text-emerald-400 dark:hover:text-emerald-300"
                >
                    {isExpanded ? "Show less" : "Show more"}
                </button>
            )}
        </div>
    );
}
